import axios from 'axios'

export default {
    getInscripcionByToken(token){
        return axios.get(`/inscripciones/comprobantes/${encodeURIComponent(token)}`)
    },
    uploadComprobante(formData){
        return axios.post('/inscripciones/comprobante', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }
}